// extracted by mini-css-extract-plugin
export default {"popup":"z7eroGLfH1MAyqeGZSbN"};